export const DialogKey = 'bulkPaymentInvoicesDialog';
